import React from "react";
import Modal from "react-bootstrap/Modal";
import { BsXCircle } from "react-icons/bs";
import CancelShift from "../components/CancelShift";

const CancelShiftModal = ({
  visible,
  close,
  shift,
  updateShift,
  cancelAction,
}) => {
  const getTitle = () => {
    if (cancelAction === "CANCEL") return "Cancel Shift";
    if (cancelAction === "REOPEN") return "Reopen Shift";
    return "Cancel or Reopen Shift";
  };

  return (
    <Modal
      show={visible}
      onHide={close}
      size="lg"
      aria-labelledby="contained-modal-title-vcenter"
      centered
    >
      <Modal.Header closeButton>
        <Modal.Title
          id="contained-modal-title-vcenter"
          className={"text-capitalize"}
        >
          <h1 className={"text-axis-offblack icon-text-wrapper"}>
            <BsXCircle className={"icon-right-spacing"} />
            {getTitle()}
          </h1>
        </Modal.Title>
      </Modal.Header>
      <Modal.Body>
        <div>
          <CancelShift
            shift={shift}
            onComplete={(s) => {
              updateShift(s);
              close();
            }}
            action={cancelAction}
            close={close}
          />
        </div>
      </Modal.Body>
    </Modal>
  );
};

export default CancelShiftModal;
